import React from 'react';
import './update-banner.scss';
import { SVGS } from '../assets';

interface UpdateBannerProps {
  visible: boolean;
  onUpdate: () => void;
  isUpdating?: boolean;
}

export const UpdateBanner: React.FC<UpdateBannerProps> = ({
  visible,
  onUpdate,
  isUpdating = false,
}) => {
  if (!visible) return null;

  return (
    <div className="update-banner">
      <div className="update-banner__content">
        {/* LEFT */}
        <div className="update-banner__left">
          <div className="update-banner__icon">
            <img src={SVGS.ZotokLogoWhite} alt="Zotok Logo" />
          </div>

          <div className="update-banner__text">
            <div className="update-banner__title font-semibold">
              New Update Available
            </div>
            <div className="update-banner__subtitle font-regular">
              Get latest features & Improvements
            </div>
          </div>
        </div>

        {/* RIGHT */}
        <button
          className="update-banner__cta font-semibold"
          onClick={onUpdate}
          disabled={isUpdating}
        >
          {isUpdating ? 'Updating...' : 'Update'}
        </button>
      </div>
    </div>
  );
};
